import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import qs from 'qs';

import {
  Localize
} from '../shared';

import {
  getIcon
} from '../../util/icons';

class AssessmentWelcome extends Component {

  state = {

  }

  render(){

    const {
      assessmentConfig,
      activeLocalization,
      orgConfig
    } = this.props;

    if(!activeLocalization){
      return null;
    }

    const assessmentName = this.props.assessmentConfig.name;
    const orgName = this.props.orgConfig.name;

    console.log('assessmentName: ', assessmentName);

    return (
      <div id="assessment-welcome" className="page">
        <div className="content-wrapper">
          <h1>
            <Localize ids={[`assessment_${assessmentName}_welcome_header`, `assessment_default_welcome_header`]} replaceWith={orgName} />
          </h1>
          <h4>
            <Localize ids={[`assessment_${assessmentName}_welcome_subheader`, `assessment_default_welcome_subheader`]} />
          </h4>
          <div className="assessment-takeaways">
            <Localize ids={[`assessment_${assessmentName}_welcome_bullets`, `assessment_default_welcome_bullets`]} breakType="steps" />
          </div>
          <button onClick={this.props.hide} className="button primary"><Localize id="btn_getstarted" /></button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    activeLocalization: state.activeLocalization.data,
    orgConfig: state.orgConfig.data
  }
}

export default connect(mapStateToProps, {})(AssessmentWelcome);



// WEBPACK FOOTER //
// ./src/components/takeAssessment/assessmentWelcome.js